import React from 'react';
import Tracking from '../../components/Tracking/Tracking';

export default function TrackingTest() {
  return <Tracking />;
}
